import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Paper, Box } from "@mui/material";
import { ApiService } from "../../ApiService";
import buscar_azul from "../../../images/search_azul.png";
import { GeneratePdfInventario } from "../../../Reports/GeneratePdfInventario";
import "../../../css/empresa_uno/ventas.css";
import { pdf as PDF } from "@react-pdf/renderer";
import Button from "@mui/material/Button";
import pdf from "../../../images/pdf.png";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import { useParams } from "react-router-dom";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";
import pdfIcon from "../../../images/pdf.png";

export const VreporteInventario = ({ selectedSucursal, convertPrice = (() => { }) }) => {
	const { nit } = useParams();
	const [objReports, setObjReports] = useState([]);
	const [reportData, setReportData] = useState(null);
	const [isPdfLoading, setPdfLoading] = useState(false);
	// Llama a /reports?key_branch=... (que SÍ devuelve { body_table: [...] })
	const fetch_reportInventory = async (key_branch) => {
		const url = `api/company/inventory/reports?key_branch=${key_branch}`;
		const options = { method: "GET" };
		const response = await ApiService.fetchData(url, options);
		if (!response || !response.body_table) {
			setObjReports([]);
			return;
		}
		setObjReports(response.body_table);
	};

	const fetchReportData = async (key_branch) => {
		const url = `api/company/inventory/list?key_branch=${key_branch}`;
		const response = await ApiService.fetchData(url);
		if (Array.isArray(response)) {
			setReportData(response);
		} else {
			setReportData(null);
		}
	};
	const exportToPdf = async () => {
		setPdfLoading(true);
		const url = `api/company/inventory/reports?key_branch=${selectedSucursal}`;
		const options = { method: "GET" };
		const response = await ApiService.fetchData(url, options);
		if (response !== null) {
			const myDoc = <GeneratePdfInventario data={response} themeColor={'var(--theme-company)'} convertPrice={convertPrice} />;
			const asPdf = PDF(myDoc);
			const blob = await asPdf.toBlob();
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;
			link.download = "Inventario.pdf";
			link.click();
			URL.revokeObjectURL(fileURL);
		}
		setPdfLoading(false);
	};
	// Al montar o cambiar selectedSucursal, obtén los datos para la tabla y para el PDF
	useEffect(() => {
		if (selectedSucursal) {
			fetch_reportInventory(selectedSucursal);
			fetchReportData(selectedSucursal);
		}
	}, [selectedSucursal]);

	// Totales para la tabla en pantalla
	const totales = {
		cantidad: Array.isArray(objReports) ? objReports.reduce((acc, item) => acc + item.stock, 0) : 0,
		costo: Array.isArray(objReports) ? objReports.reduce((acc, item) => acc + parseFloat(item.purchase_price), 0).toFixed(2) : 0,
		costoT: Array.isArray(objReports) ? objReports.reduce((acc, item) => acc + (parseFloat(item.purchase_price) * parseInt(item.stock)), 0).toFixed(2) : 0,
		beneficio: Array.isArray(objReports)
			? objReports
				.reduce((acc, item) => acc + (parseFloat(item.price1) - parseFloat(item.purchase_price)), 0)
				.toFixed(2)
			: 0,
		precio: Array.isArray(objReports)
			? objReports.reduce((acc, item) => acc + parseFloat(item.price1), 0).toFixed(2)
			: 0,
	};

	return (
		<div>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Reporte de inventario</h2>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="reporte de inventario" />

						<div style={{ display: 'none' }}>
							<button className="btn-add-var">
								<img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
								<span className="txt-add">PDF</span>
							</button>
						</div>
					</div>

					<Button
						variant="contained"
						color="primary"
						onClick={exportToPdf}
						disabled={isPdfLoading}
						startIcon={<PictureAsPdfIcon />}
						sx={{ textTransform: "none", height: 41, background: 'var(--theme-company)' }}
					>
						{isPdfLoading ? "Generando PDF..." : "PDF"}
					</Button>
				</div>
			</div>

			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
							{["FECHA", "CÓDIGO", "PRODUCTO", "STOCK", "PRECIO COMPRA", "COSTO TOTAL", "BENEF", "PRECIO VENTA"].map(
								(header, index) => (
									<TableCell
										key={index}
										sx={{
											color: "white",
											fontWeight: "bold",
											textAlign: "center",
											fontSize: "0.9rem",
										}}>
										{header}
									</TableCell>
								)
							)}
						</TableRow>
					</TableHead>

					<TableBody>
						{Array.isArray(objReports) &&
							objReports.map((item, idx) => (
								<TableRow key={idx}>
									<TableCell align="center">{item.last_update}</TableCell>
									<TableCell align="center">{item.code}</TableCell>
									<TableCell align="center">{item.name}</TableCell>
									<TableCell align="center">{item.stock}</TableCell>
									<TableCell align="center">{convertPrice(item.purchase_price, null, true)}</TableCell>
									<TableCell align="center">{convertPrice(parseInt(item.stock) * parseFloat(item.purchase_price), null, true)}</TableCell>
									<TableCell align="center">
										{convertPrice((parseFloat(item.price1) - parseFloat(item.purchase_price, null, true)), null, true)}
									</TableCell>
									<TableCell align="center">{convertPrice(item.price1, null, true)}</TableCell>
								</TableRow>
							))}
					</TableBody>

					<TableFooter>
						<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
							<TableCell align="center" colSpan={3} sx={{ color: "white", fontWeight: "bold" }}>
								TOTAL
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{totales.cantidad}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(totales.costo)}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(totales.costoT)}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(totales.beneficio)}
							</TableCell>
							<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
								{convertPrice(totales.precio)}
							</TableCell>
						</TableRow>
					</TableFooter>
				</Table>
			</TableContainer>
			<br></br>
		</div>
	);
};
